var exports = {
  "_": "xe564cbfb--3fefb3--img",
  "q": "xe564cbfb--3fefb3--footer",
};

module.exports = exports;
